import cn from 'classnames';
import React, {FC} from 'react';

import styles from './Button.module.scss';
import ButtonRaw from './ButtonRaw';
import {IButton} from './ButtonTypes';

const Button: FC<IButton> = ({children, className, ...props}) => {
    const btnClassName = cn(styles.Button, className);

    return (
        <ButtonRaw {...props} className={btnClassName}>
            {children}
        </ButtonRaw>
    );
};

export default Button;
